var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-select',{attrs:{"label":_vm.label,"items":_vm.filtros,"item-text":"text","item-value":"key","value":_vm.value},on:{"input":function($event){return _vm.onChange($event)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }